import { generatePath } from 'react-router-dom'
import { TradingAccountType } from 'api/Clients/Types/TradingAccount'
import { links } from 'utils/featureToggles'

export const generateRoutePathByAccountGroupType = (
  type: TradingAccountType,
  tradingAccountId: string
): string => {
  switch (type) {
    case TradingAccountType.DEMO: {
      return generatePath(links.recordsDemoAccounts.detailsUrl as string, {
        id: tradingAccountId,
        slug: 'details',
      })
    }
    case TradingAccountType.LIVE: {
      return generatePath(links.recordsTradingAccounts.detailsUrl as string, {
        id: tradingAccountId,
        slug: 'details',
      })
    }
    case TradingAccountType.WELCOME: {
      return generatePath(links.recordsWelcomeAccounts.detailsUrl as string, {
        id: tradingAccountId,
        slug: 'details',
      })
    }
  }
}
